import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';
import _ from "lodash";

const SLICE_NAME = 'recording';

export const startRecordingRequest = createAsyncThunk(
    "recording/startRecordingRequest",
    async (request) => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/recordings", request);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }

    }
);

export const stopRecordingRequest = createAsyncThunk(
    "recording/stopRecordingRequest",
    async (request) => {
        try {
            const response = await Rest.put(ApiGatewayUrl + "/recordings", request);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const recordingSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        recordingList: [],
        recordings: []
    },

    reducers: {
        stopRecording: (state, action) => {
            let recordings = state.recordings;
            let result = _.filter(recordings, s => s.deviceId !== action.payload.deviceId);
            state.recordings = result
        },
        updateRecording: (state, action) => {
            let recordings = state.recordings;
            let existedRecord = _.find(recordings, r => r.deviceId == action.payload.deviceId && r.recording_id == action.payload.recording_id)
            if (!existedRecord) {
                recordings.push({
                    deviceId: action.payload.deviceId,
                    recording_id: action.payload.recording_id,
                    video_task_id: action.payload.video_task_id
                })
            }
        }
    }
});

export const recordingActions = recordingSlice.actions;
export const recordingState = (state) => state.recording;
export default recordingSlice.reducer;